import { Button } from '@app/components/various/Button';
import { Form, FormFieldset, FormGrid, InputField } from '@app/components/various/Form';
import { StickyModalFooter } from '@app/components/various/Modal';
import { useValidatedForm } from '@app/utils/hooks/useValidatedForm';
import { Lookbook } from '@typings';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

interface FormData {
  label: string;
}

interface Props {
  navigationItem: Lookbook.FolderNavigationItem;
  onCancel?: () => void;
  onEdit?: (navigationItem: Lookbook.FolderNavigationItem) => void;
}

export const EditFolderForm = ({ navigationItem, onCancel, onEdit }: Props) => {
  const { t } = useTranslation(['common', 'cms', 'menu', 'settings', 'validation']);

  const validationSchema = yup.object<FormData>({
    label: yup.string().required(t('validation:navigation_label_hint')),
  });

  const formMethods = useValidatedForm<FormData>({
    defaultValues: {
      label: navigationItem.label,
    },
    validationSchema,
  });

  const handleSubmit = (data: FormData) => {
    onEdit?.({ ...navigationItem, ...data });
  };

  return (
    <Form formMethods={formMethods} onSubmit={handleSubmit}>
      <FormFieldset>
        <FormGrid>
          <InputField
            label={t('settings:navigation_label')}
            placeholder={t('settings:navigation_label')}
            {...formMethods.register('label')}
          />
        </FormGrid>
      </FormFieldset>
      <StickyModalFooter>
        <div className="mt-4 flex justify-end gap-2">
          <Button color="secondary" variant="ghost" onClick={onCancel}>
            {t('common:cancel')}
          </Button>
          <Button type="submit">{t('common:save')}</Button>
        </div>
      </StickyModalFooter>
    </Form>
  );
};
